var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['underscore'], function(_) {
  var LedgerStorage;
  return LedgerStorage = (function() {

    function LedgerStorage(accountStatementId) {
      this.localStorageKey = "reconciliationLedgers_" + accountStatementId;
      this.maxStored = 100;
      this.maxCleared = this.maxStored / 2;
    }

    /*
    Save the ledger to local storage.
    
    * If number of reconciliation storage keys equals @maxStored, delete oldest n rec keys
    * If local storage is full, clear the oldest n rec keys, then retry.
    */


    LedgerStorage.prototype.save = function(ledgers) {
      var clearReconciliationStorage, reconciliationKeys, regex, setReconciliationStorage,
        _this = this;
      regex = /^reconciliationLedgers_/;
      reconciliationKeys = _.filter(Object.keys(localStorage), function(key) {
        return regex.test(key) && key !== _this.localStorageKey;
      });
      if (reconciliationKeys == null) {
        reconciliationKeys = [];
      }
      setReconciliationStorage = function() {
        return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.setItem(_this.localStorageKey, JSON.stringify(ledgers)) : void 0;
      };
      clearReconciliationStorage = function() {
        var key, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = reconciliationKeys.length; _i < _len; _i++) {
          key = reconciliationKeys[_i];
          if (__indexOf.call(_.first(reconciliationKeys, _this.maxCleared), key) >= 0) {
            _results.push(_this.remove(key));
          }
        }
        return _results;
      };
      if (reconciliationKeys.length >= this.maxStored) {
        clearReconciliationStorage();
      }
      try {
        return setReconciliationStorage();
      } catch (error) {
        clearReconciliationStorage();
        return setReconciliationStorage();
      }
    };

    LedgerStorage.prototype.load = function() {
      var ledgers;
      ledgers = JSON.parse(typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem(this.localStorageKey) : void 0);
      return ledgers != null ? ledgers : ledgers = {};
    };

    LedgerStorage.prototype.update = function(id, ledgerId) {
      var ledgers;
      ledgers = this.load();
      ledgers[id] = ledgerId;
      return this.save(ledgers);
    };

    LedgerStorage.prototype.remove = function(key) {
      if (key == null) {
        key = this.localStorageKey;
      }
      return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.removeItem(key) : void 0;
    };

    return LedgerStorage;

  })();
});
